import React from 'react';
import { Building2, Package, Wrench, CheckCircle2 } from 'lucide-react';
export function CommercialStrip() {
  return <section className="bg-brand-goldWash text-brand-charcoal py-16 lg:py-24" data-id="element-200">
      <div className="max-w-7xl mx-auto px-4" data-id="element-201">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-202">
          <div className="lg:col-span-5" data-id="element-203">
            <span className="text-brand-charcoal font-bold tracking-wider uppercase text-xs mb-4 block flex items-center gap-2" data-id="element-204">
              <span className="w-6 h-px bg-brand-charcoal" data-id="element-205"></span>
              B2B & Community Projects
            </span>
            <h2 className="text-3xl lg:text-4xl font-serif font-bold mb-6 leading-tight" data-id="element-206">
              Commercial mailbox projects need more than a product grid
            </h2>
            <p className="text-brand-charcoal/90 text-lg mb-6 leading-relaxed" data-id="element-207">
              Commercial mailbox requirements can vary by product, location,
              delivery setup, USPS/project requirements, and installation type.
              MidAtlantic helps property managers, HOAs, developers, apartments,
              and offices think through door counts, parcel lockers, numbering,
              replacement parts, and project planning before the order is
              placed.
            </p>

            <ul className="space-y-3 mb-8 text-brand-charcoal/80 text-sm" data-id="element-208">
              <li className="flex items-start gap-2" data-id="element-209">
                <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-210" />
                <span data-id="element-211">Free commercial estimating and diagnostic help</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-212">
                <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-213" />
                <span data-id="element-214">CBU, 4C, and parcel locker planning</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-215">
                <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-216" />
                <span data-id="element-217">Replacement locks, doors, hinges, and parts</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-218">
                <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-219" />
                <span data-id="element-220">USPS/project requirement awareness</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-221">
                <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-222" />
                <span data-id="element-223">Community route and development planning</span>
              </li>
            </ul>

            <div className="flex flex-wrap gap-4" data-id="element-224">
              <a href="/6m8/commercial-mailboxes-lockers.html" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-6 py-3 rounded-md font-bold transition-colors shadow-sm" data-id="element-225">
                Shop commercial mailboxes
              </a>
              <a href="/ContactUs.html" className="bg-white hover:bg-brand-goldSoft border border-brand-charcoal/20 text-brand-charcoal px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-226">
                Request project help
              </a>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-227">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6" data-id="element-228">
              <a href="/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html" className="bg-white border border-brand-border hover:border-brand-maroon/40 hover:shadow-sm transition-all rounded-xl p-6 lg:p-8 flex flex-col items-center text-center group" data-id="element-229">
                <div className="w-14 h-14 bg-brand-goldSoft text-brand-maroon rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-230">
                  <Building2 size={28} strokeWidth={1.5} data-id="element-231" />
                </div>
                <h3 className="font-serif font-bold text-lg mb-2 text-brand-charcoal" data-id="element-232">
                  Centralized Delivery
                </h3>
                <p className="text-sm text-brand-charcoal/80 leading-relaxed" data-id="element-233">
                  CBU and 4C systems
                </p>
              </a>

              <a href="/6m8/commercial-mailboxes-lockers/parcel-lockers.html" className="bg-white border border-brand-border hover:border-brand-maroon/40 hover:shadow-sm transition-all rounded-xl p-6 lg:p-8 flex flex-col items-center text-center group" data-id="element-234">
                <div className="w-14 h-14 bg-brand-goldSoft text-brand-maroon rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-235">
                  <Package size={28} strokeWidth={1.5} data-id="element-236" />
                </div>
                <h3 className="font-serif font-bold text-lg mb-2 text-brand-charcoal" data-id="element-237">
                  Parcel lockers
                </h3>
                <p className="text-sm text-brand-charcoal/80 leading-relaxed" data-id="element-238">
                  Secure package management
                </p>
              </a>

              <a href="/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-doors.html" className="bg-white border border-brand-border hover:border-brand-maroon/40 hover:shadow-sm transition-all rounded-xl p-6 lg:p-8 flex flex-col items-center text-center group" data-id="element-239">
                <div className="w-14 h-14 bg-brand-goldSoft text-brand-maroon rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-240">
                  <Wrench size={28} strokeWidth={1.5} data-id="element-241" />
                </div>
                <h3 className="font-serif font-bold text-lg mb-2 text-brand-charcoal" data-id="element-242">
                  Replacement parts
                </h3>
                <p className="text-sm text-brand-charcoal/80 leading-relaxed" data-id="element-243">
                  Commercial doors, locks, and hardware
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}